module.exports = "https://cdn2-fs.clearscore.com/flux/images/5c5707f9d627e580d046d801e6bad9cb.jpg";